import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ButtonGroup,
  Table
} from 'reactstrap';
import StorageService from '../services/StorageService';
import axios from 'axios';
import {
  MdDone,
  MdClear,
  MdCreate,
  MdCancel,
  MdCameraAlt,
} from 'react-icons/md';

class FeatureForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      has_store: false,
      set_main_page: false,
      rSelected: null,
      feature: '',
      countFeature: 0,
      details: null,
      featureList: [
        {
          id: null,
          name: 'Personnel',
          status: 0,
        },
        {
          id: null,
          name: 'POS',
          status: 0,
        },
        {
          id: null,
          name: 'CRM',
          status: 0,
        },
        {
          id: null,
          name: 'Configuration',
          status: 0,
        },
        {
          id: null,
          name: 'User',
          status: 0,
        },
      ],
    };
  }

  toggleStoreListing = event => {
    this.setState({ has_store: event.target.checked });
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    const data = {
      session_key: user.session_key,
      CompanyID: this.props.data.selectedCompanyId,
      Status: event.target.checked,
    };
    axios
      .post(url + ':3000/v1/company/toggleStoreListing', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          alert(result.message);
          return;
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  openLicensing = (company_id, name) => {
    const url = process.env.REACT_APP_UNITY_API2_URL;

    const data = {
      session_key: process.env.REACT_APP_UNITY_API2_KEY,
      company_id: company_id,
      company_name: name
    };

    axios
      .post(url + ':3001/v2/licensing', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          alert(result.message);
          return;
        }
      })
      .catch(error => {
        alert(error);
      });
  }

  updateCompanyPOSFeature = (disable, company_id) => {
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const formData = {
      session_key: process.env.REACT_APP_UNITY_API2_KEY,
      company_id: company_id,
      disable: disable > 0 ? 0 : 1
    };

    axios
      .post(url + ':3001/v1/license/disable/set', formData)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          alert(result.message);
        }
      })
      .catch(error => {
        alert(error);
      }); 
  };

  update = (id, name, status, order) => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    const org = StorageService.getSession('selected_org');

    const data = {
      session_key: user.session_key,
      CompanyID: this.props.data.selectedCompanyId,
      ID: id,
      Feature: name,
      Status: status,
      Order: order,
    };
    axios
      .post(url + ':3000/v1/company/setFeature', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          alert(result.message);
          return;
        }

        if(name === 'POS') {
          this.updateCompanyPOSFeature(status, this.props.data.selectedCompanyId); 
          // if(status == 1) {
          //   this.openLicensing(this.props.data.selectedCompanyId, this.props.data.selectedData);
          // }
        }   
        this.getFeatureList();
      })
      .catch(error => {
        alert(error);
      });
  };

  getFeatureList = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    const org = StorageService.getSession('selected_org');

    const data = {
      session_key: user.session_key,
      CompanyID: this.props.data.selectedCompanyId,
    };

    axios
      .post(url + ':3000/v1/company/getFeature', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }

        let features = [...this.state.featureList];

        if (org.CompanyID === this.props.data.selectedCompanyId) {
          org.Features = result.data;
          StorageService.setSession('selected_org', org);
        }
        if (result.data.length) {
          let count = 0;
          for (let i of features) {
            const found = result.data.findIndex(e => e.Feature === i.name);
            features[count].status = found > -1 ? 1 : 0;

            if (found > -1) {
              const dt = result.data.find(e => e.Feature === i.name);
              features[count].id = dt.Id;
            }
            count++;
          }
        }

        let countFeature = 0;
        for (let f of features) {
          if (f.status > 0) {
            countFeature++;
          }
        }

        this.setState({ featureList: features, countFeature: countFeature });
      })
      .catch(error => {
        alert(error);
      });
  };

  getCompanyDetail = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    const org = StorageService.getSession('selected_org');

    const data = {
      session_key: user.session_key,
      CompanyID: this.props.data.selectedCompanyId,
    };

    axios
      .post(url + ':3000/v1/company/edit', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }

        if(result.data) {
          let has_store = result.data.Has_Store > 0 ? true: false;
          this.setState({ details: result.data, has_store: has_store });
        }
        
      })
      .catch(error => {
        alert(error);
      });
  };

  componentDidMount() {
    this.getCompanyDetail();
    this.getFeatureList();
  }

  render() {
    return (
      <>
        <ModalHeader toggle={this.props.onToggleModal()}>
          Enable Feature
        </ModalHeader>
        <ModalBody>
          <Table style={{ fontSize: '0.85rem' }}>
            <tbody>
              {this.state.featureList.length > 0 &&
                this.state.featureList.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <span>{item.name}</span>
                      </td>
                      <td className="text-right">
                        <Button
                          color="link"
                          className="theme-button theme-button-primary"
                          className={
                            'theme-button ' +
                            (item.status > 0
                              ? 'theme-button-primary-light'
                              : 'theme-button-primary')
                          }
                          onClick={() =>
                            this.update(
                              item.id,
                              item.name,
                              item.status > 0 ? 0 : 1,
                              index + 1,
                            )
                          }
                          disabled={
                            item.status > 0 && this.state.countFeature < 2
                              ? true
                              : false
                          }
                        >
                          {item.status > 0 ? 'Disable' : 'Enable'}
                        </Button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>

          {this.state.featureList.length > 0 &&
                this.state.featureList.some(e => e.name === 'POS' && e.status === 1) && <FormGroup check>
                <Label check style={{fontSize:'0.85rem'}}>
                  <Input type="checkbox" name="has_store" checked={this.state.has_store} onChange={this.toggleStoreListing} />{' '}
                  Set store listing as eCart main page
                </Label>
              </FormGroup>}
              <br/>
              <small>Note that POS licensing will be enabled/disabled as well when you enable/disable POS feature.</small>
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={() =>
              this.props.closeModal(
                <MdClear />,
                'Feature updated succesfully',
                'success',
                false
              )
            }
          >
            Close
          </Button>
        </ModalFooter>
      </>
    );
  }
}

export default FeatureForm;
